<template>
  <Drawer
    placement="left"
    :closable="false"
    v-model="openPoint"
    width="280"
    draggable
    class="my-drawer"
    title="路线规划"
  >
    <div id="pointList">
      <Input
        v-model="keyword"
        search
        placeholder="请输入关键字"
        @on-search="getList"
      ></Input>

      <ul>
        <li
          @click="clickItem(item)"
          v-for="(item, index) in tableData"
          :key="index"
          :class="{ active: item.select }"
        >
          {{ item.name }}
        </li>
      </ul>
      <Button long @click="checkAll" type="primary">{{
        isAll ? "取消选择" : "选择全部"
      }}</Button>
    </div>
  </Drawer>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openPoint: false,
      tableData: [],
      selectData: [],
      isAll: false,
      keyword: "",
    };
  },
  methods: {
    open() {
      this.openPoint = true;
    },
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.rule + "/route/list",
        data: { keyword: this.keyword },
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].select = false;
          this.getItem(data[i]);
        }
        //var data = [{ name: "11111" }];
        this.tableData = data;
      });
    },
    getItem(row) {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.rule + "/route/item",
        data: { id: row.id },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          var aaa = res.data.data.coordList;
          row.coordList = aaa;
        }
      });
    },
    push() {
      this.selectData = [];
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].select) {
          this.selectData.push(this.tableData[i]);
        }
      }
      if (this.selectData.length == this.tableData.length) {
        this.isAll = true;
      }

      this.$emit("lines", this.selectData);
    },
    clickItem(v) {
      v.select = !v.select;
      this.push();
    },
    checkAll() {
      this.isAll = !this.isAll;
      if (this.isAll) {
        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].select = true;
        }
        this.selectData = this.tableData;
      } else {
        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].select = false;
        }
        this.selectData = [];
      }
      this.$emit("lines", this.selectData);
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style lang="">
#pointList {
  height: 100%;
}
#pointList ul {
  height: calc(100% - 80px);
  margin: 10px auto;
  overflow: auto;
}
#pointList li {
  padding: 10px;
  cursor: pointer;
}
#pointList li.active {
  background: #d9ebfe;
}
</style>


// WEBPACK FOOTER //
// src/components/common/lineList.vue